const actionTypes = {
	SET_ACTION_ITEMS: 'SET_ACTION_ITEMS',
	SET_ACTION_CATEGORIES: 'SET_ACTION_CATEGORIES',
	SET_VIDEO_MODAL_OPEN: 'SET_VIDEO_MODAL_OPEN',
	SET_VIDEO_MODAL_ITEM: 'SET_VIDEO_MODAL_ITEM',
	SET_LEARN_MORE_DIALOG_OPEN: 'SET_LEARN_MORE_DIALOG_OPEN',
	SET_LEARN_MORE_DIALOG_ITEM: 'SET_LEARN_MORE_DIALOG_ITEM',
};

export default actionTypes;
